<template>
	<div class="music-wave">

	</div>
</template>

<script>

	import wave from "../audio/waveview";

	export default {
		name: "MusicWave",
	}
</script>

<style scoped>

</style>